<template>
  <router-view />
</template>


<script setup>
</script>

<style>
/* Supprime l’ancien style global qui forçait le center + couleur */
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>